import { isMiniWechatWebView } from "./app/common";
import { onMounted, onUnmounted, ref, computed } from "vue";

export type TDeviceEnvironment =
  | "pc-wechat"
  | "phone-wechat"
  | "desktop-app"
  | "pc-web"
  | "phone-web";

export function getEnvironment(): TDeviceEnvironment {
  // #ifdef H5
  let result: TDeviceEnvironment;
  const ng = navigator.userAgent;
  const detectDeviceType =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|Mobile|IEMobile|Opera Mini/i.test(
      ng
    )
      ? false
      : true;
  const ua = window ? window.navigator.userAgent.toLowerCase() : "";
  if (
    ua.match(/MicroMessenger/i)?.[0] == "micromessenger" &&
    ua.match(/wxwork/i)?.[0] != "wxwork"
  ) {
    // 是微信客户端
    result = detectDeviceType ? "pc-wechat" : "phone-wechat";
  } else {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (ng.indexOf("csdgpt") != -1 || window.win_message !== undefined) {
      result = "desktop-app";
    } else {
      result = detectDeviceType ? "pc-web" : "phone-web";
    }
  }
  return result;
  // #endif
}

export const isMobile =
  getEnvironment().includes("phone") || isMiniWechatWebView();
export const isPc = getEnvironment().includes("pc") && !isMiniWechatWebView();
export const isWeChat = getEnvironment().includes("wechat");
export const isAndroid = navigator.userAgent
  .toLocaleLowerCase()
  .includes("android");

export const isWeb = getEnvironment().includes("web");
export const isDesktop = getEnvironment().includes("desktop");

export function getDeviceWidth() {
  const viewWidth = ref(document.body.offsetWidth);
  function update() {
    viewWidth.value = document.body.offsetWidth;
  }
  onMounted(() => window.addEventListener("resize", update));
  onUnmounted(() => window.removeEventListener("resize", update));
  return viewWidth;
}

export function getPageTitle() {
  const env = getEnvironment();
  if (env.includes("wechat")) {
    return "deepSeek";
  }
  return "deepSeek";
}
